import React, {
  useMemo,
  useState,
  useCallback,
} from 'react'

import {
  Button,
} from '@usap/uicomponents'

import { usePopUpContext } from '../../../../../providers/PopUpProvider'
import useRemoveItemsCallback from '../../../../../hooks/actions/useRemoveItemsCallback'
import useContinueShopping from '../../../../Summary/ProceedToCheckout/Regular/hooks/useContinueShopping'
import useWmoEnabled from '../../../../../../../hooks/useWmoEnabled'
import ButtonWmo from '../../../../../../Wmo/ButtonWmo/ButtonWmo'

const RemoveAndContinueShopping = params => {
  const { data } = params

  const {
    shouldShowOosProducts,
  } = usePopUpContext()

  const [isProcessing, setIsProcessing] = useState(false)

  const isWmoEnabled = useWmoEnabled()

  const buttonLabel = useMemo(
    () => {
      if (isProcessing) return 'Removing item(s)...'
      return isWmoEnabled ? 'Remove Item(s) and Keep Shopping' : 'Remove item(s) and continue shopping'
    },
    [isProcessing, isWmoEnabled],
  )

  const removeItems = useRemoveItemsCallback()
  const handleContinueShopping = useContinueShopping()

  const handleAction = useCallback(
    async () => {
      setIsProcessing(true)
      const items = [...data]

      await removeItems(items)
      await handleContinueShopping(data)
      setIsProcessing(false)
      shouldShowOosProducts(false)
    },
    [setIsProcessing, data, removeItems, shouldShowOosProducts, handleContinueShopping],
  )

  if (isWmoEnabled) {
    return (
      <ButtonWmo
        disabled={isProcessing}
        label={buttonLabel}
        onClick={handleAction}
      />
    )
  }

  return (
    <Button
      custom
      hideBorder={false}
      disabled={isProcessing}
      label={buttonLabel}
      onClick={handleAction}
    />
  )
}

export default RemoveAndContinueShopping
